import React from "react";
import '../custom frames/frame-style.scss'
import FrameWithButton from "./FrameWithButton";
import SimpleFrame from "./SimpleFrame";
import { useTranslation } from 'react-i18next';

const FrameContentTop = () => {
    const { t } = useTranslation();
    return (
        <div class="frame-content">
            <SimpleFrame
                style={"frame-home-gray"}
                title={t('home.mission')}
                contentMessage={t('home.missionText')}
            ></SimpleFrame>

            <FrameWithButton
                style={"frame-home-purple"}
                title={t('home.contributionImportant')}
                subtitle={t('home.helpUsDonate')}
                buttonTitle={t('home.donateHere')}
                buttonLink={"https://www.paypal.com/donate/?hosted_button_id=NP4DH8ZJ2XJKU"}
            ></FrameWithButton>
        </div>
    );
}


export default FrameContentTop;
